import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/i-05.png'
import _imports_1 from '@/assets/icon/search.png'


const _withScopeId = n => (_pushScopeId("data-v-bd6fb5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-class-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "search-class" }, [
    /*#__PURE__*/_createTextVNode(" 设计方案"),
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("ul", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "免费设计方案"),
    /*#__PURE__*/_createElementVNode("li", null, "机械原理动画"),
    /*#__PURE__*/_createElementVNode("li", null, "工业自动化设备")
  ])
], -1))
const _hoisted_4 = { class: "search-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recommend" }, [
  /*#__PURE__*/_createElementVNode("span", null, "无痕吸盘"),
  /*#__PURE__*/_createElementVNode("span", null, "袋装液体"),
  /*#__PURE__*/_createElementVNode("span", null, "充气软袋"),
  /*#__PURE__*/_createElementVNode("span", null, "气动夹爪"),
  /*#__PURE__*/_createElementVNode("span", null, "平面多褶洗盘")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
          placeholder: "软包装三抓"
        }, null, 512), [
          [_vModelText, _ctx.message]
        ])
      ]),
      _createElementVNode("div", {
        class: "search-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSearch()))
      }, _hoisted_6)
    ]),
    _hoisted_7
  ]))
}